"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetworkMANADescription = exports.getNetworkName = exports.networksNames = void 0;
var schemas_1 = require("@dcl/schemas");
exports.networksNames = (_a = {},
    _a[schemas_1.Network.ETHEREUM] = 'Ethereum',
    _a[schemas_1.Network.MATIC] = 'Polygon',
    _a[schemas_1.Network.ARBITRUM] = 'Arbitrum',
    _a[schemas_1.Network.AVALANCHE] = 'Avalanche',
    _a[schemas_1.Network.FANTOM] = 'Fantom',
    _a[schemas_1.Network.BSC] = 'Binance Smart Chain',
    _a[schemas_1.Network.OPTIMISM] = 'Optimism',
    _a);
var getNetworkName = function (network) {
    return exports.networksNames[network];
};
exports.getNetworkName = getNetworkName;
var getNetworkMANADescription = function (network) {
    var networkName = (0, exports.getNetworkName)(network);
    return networkName ? "".concat(networkName, " MANA") : 'MANA';
};
exports.getNetworkMANADescription = getNetworkMANADescription;
